import React from "react"
import { CircularProgress } from "@material-ui/core"

export function Loader() {
  return <CircularProgress size={24} style={{ height: 24 }} />
}
